module.exports = __webpack_public_path__ + "img/inst-modal-10.d039b44b.png";